@if (isPending) {
  <div class="action-buttons-cell">
    <button mat-raised-button color="primary" (click)="onSign()">
      Sign Now
    </button>
    <button mat-button color="warn" (click)="onVoid()" [disabled]="isVoiding">
      Void
    </button>
  </div>
} @else if (isCompleted && hasDownloadableDocument) {
  <button mat-icon-button color="primary"
    (click)="onDownload()"
    matTooltip="Download Agreement">
    <mat-icon>download</mat-icon>
  </button>
} @else if (isCompleted && !hasDownloadableDocument) {
  <mat-icon
    matTooltip="Document is being processed. Please refresh in a moment."
    style="color: gray; cursor: default;">
    hourglass_empty
  </mat-icon>
} @else {
  <span>-</span>
}
